'use strict';

module.exports = /* @ngInject */ function() {
	return {
		restrict: 'E',
		scope: {
		},
		templateUrl: `./${BUILD_PATH}/header-client-basket.directive.html`,
		controller: /* @ngInject */ function ($scope) {
		}
	};
}
